import { PropsWithChildren, useCallback, useRef } from 'react';
import { SiloRealFormContext } from './form-context';

export function SiloRealFormProvider({ children }: PropsWithChildren) {
  const contextValue = InternalSiloRealFormContext();
  return <SiloRealFormContext.Provider value={contextValue}>{children}</SiloRealFormContext.Provider>;
}

export function InternalSiloRealFormContext() {
  const uniqueValues = useRef<Set<string>>(new Set());

  const assertUniqueValue = useCallback((str: string) => {
    if (uniqueValues.current.has(str)) {
      // eslint-disable-next-line no-console
      console.warn('[SiloReal][Form][Context] Name is not unique: ' + str);
    }
    uniqueValues.current.add(str);
  }, []);

  return {
    verify: {
      uniqueness: assertUniqueValue,
    },
  };
}
